import NavPublicUser from "../navbarPublicUser";
import Footer from "../Footer";
import CategoryPubBody from "../CategoryPubBody";
export default function PubCategory(){

    return(
        <div>
            <NavPublicUser />
            <CategoryPubBody />
            <Footer />

        </div>

    )




}